import React from 'react'
import {Button, Modal, ModalBody, FormFeedback,Col, Form, Row, Label } from 'reactstrap';
import {ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styleM.css';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';


export const ModalAutorization = (props) => {

    const {user_method, user_password_method,handleInputChangeMethod,modalAutorization,toggleModalAutorization,validatePasswordFinance,handleCancelAutorization,name_User,configuration_role,handleSendNotificationInvoices} = props;
    
    return (
        <Dialog
            header={"Autorizar Factura"}
            visible={modalAutorization}
            onHide={toggleModalAutorization}
            closable={true}
            modal
            blockScroll
            className='tiny-dialog'
        >

            <Form className="form theme-form" role="form">
                <ModalBody>   
                
                    {
                        configuration_role === "True" ?
                        <>
                                                            
                            <h6 className=" f-w-600">
                                Usuario autorizar: <strong className='font-primary f-w-600'> {name_User} </strong>
                            </h6>

                            <Row>
                                <Col sm="12">
                                    <Label style={{fontSize: "12px"}}>Usuario</Label>
                                    <InputText
                                        value={user_method}
                                        name="user_method"
                                        onChange={handleInputChangeMethod}
                                        required={true}
                                        autoComplete="nope"
                                        className="p-mb-2"
                                        style={{ width: '100%' }}
                                    />
                                    <FormFeedback>Escribe el usuario</FormFeedback>

                                </Col>

                                <Col sm="12" className='mt-1'>
                                    <Label style={{fontSize: "12px"}}>Contraseña</Label>
                                   <Password
                                        name="user_password_method"
                                        value={user_password_method}
                                        onChange={handleInputChangeMethod}
                                        feedback={false}
                                        className="p-mb-2"
                                        style={{ width: '100%' }}
                                        inputStyle={{ width: '100%' }}
                                    />

                                    <FormFeedback>Escribe el usuario</FormFeedback>
                                </Col>
                            </Row>


                            <Col sm="12" style={{textAlign : "right"}} className='p-l-0 p-r-0' > <br />
                                <div className="btngroup">
                                    <Button color="primary text-center" type="button" className='mr-2' onClick={validatePasswordFinance} >{"Autorizar"}</Button> 

                                    <Button color="danger text-center" type="button" onClick={handleCancelAutorization}>{"Cancelar"}</Button> <ToastContainer />
                                </div> 
                            </Col>
                        </>
                        :
                        <Col sm="12" style={{textAlign : "center"}} className='p-l-0 p-r-0 '>
                          
                        <img className="img-fluid" src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "80%" }} alt="" />
                        <br />
                         <p className='f-w-600 f-14 badge badge-light-danger' >Contacte a Administracion.</p>
                         <br />
                         <Col sm="12" style={{textAlign : "right"}} className='p-l-0 p-r-0' > <br />
                            <div className="btngroup">
                                <Button color="danger text-center" type="button" onClick={handleSendNotificationInvoices}>{"Aceptar"}</Button>
                            </div> 
                        </Col>
                        </Col>
                    }
              
                </ModalBody>
            </Form>
        </Dialog>
    )
}
